
import { DataClient } from "@/services/DataClient";
import { useLocationStore } from "@/stores/LocationStore";
import { Component, Vue, Watch } from "vue-property-decorator";
import { RouterView } from "vue-router";

import Header1Section from "@/sections/Header1Section.vue";
import { BaseView } from "@/services/BaseView";
import { loadLanguageAsync } from "@/i18n";

@Component({
    components: {
        Header1Section,
    },
})
export default class extends BaseView {
    sidebar = false;
    language = this.$i18n.locale;

    showLanguageSelector = true;

    targetElevation = 0;
    targetBackgroundColor = "transparent";

    languages = [
        {
            title: "Español",
            code: "es",
        },
        {
            title: "English",
            code: "en",
        },
        {
            title: "Română",
            code: "ro",
        },
    ];

    // @Watch("$vuetify.breakpoint.smAndDown", { immediate: true })
    // onBreakpointChanged(value: boolean) {
    //     console.log("onBreakpointChanged", value);
    //     this.sidebar = false;
    // }

    created() {
        useLocationStore().initialize();
    }

    get mallorca() {
        const category = DataClient.instance.getCategoryById("3bd27efd-b78f-4050-a7f1-c2526f6c5a12");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    get costaBrava() {
        const category = DataClient.instance.getCategoryById("50aea81e-ef50-451c-9105-7ef110c8de51");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    get costaDelSol() {
        const category = DataClient.instance.getCategoryById("c5273aab-bbae-4af9-850c-f6c69b1a09b4");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    get tenerife() {
        const category = DataClient.instance.getCategoryById("52f99a4d-fb7b-4704-94f8-25b05b692535");
        return this.buildNavigationRoute("category", { id: category.slug });
    }

    async setLanguage(code: string) {
        // await DataClient.instance.loadConfiguration(code);
        // this.$router.push({ name: "home" + "." + code });

        const oldName = (this.$route.name || "").slice(0, -3);
        let id: string | undefined;

        // console.log(oldName);

        if (oldName === "category") {
            id = DataClient.instance.getCategoryBySlug(this.$route.params.id as string)?.id;
        } else if (oldName === "activity") {
            id = DataClient.instance.getActivityBySlug(this.$route.params.id as string)?.id;
        }

        const newName = oldName + "." + code;
        // console.log(newName);

        // make sure configuration is loaded
        DataClient.instance.loadConfiguration(code).then(async () => {
            await loadLanguageAsync(code);
            this.$i18n.locale = code;

            if (oldName === "category" && id) {
                this.$router.push({ name: newName, params: { id: DataClient.instance.getCategoryById(id)?.slug }, query: this.$route.query });
            } else if (oldName === "activity" && id) {
                this.$router.push({ name: newName, params: { id: DataClient.instance.getActivityById(id)?.slug }, query: this.$route.query });
            } else {
                this.$router.push({ name: newName, params: this.$route.params, query: this.$route.query });
            }
        });
    }

    agentsLogin() {
        window.open("https://agents.cubodrivers.com", "_blank");
    }

    get headerType() {
        return DataClient.instance.configuration.headerType;
    }
}
